import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Target, Zap, Heart } from 'lucide-react';
export function StartFreeBenefits() {
  return <section className="py-24 bg-off-white" data-id="element-3064">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3065">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3066">
          <h2 className="text-4xl text-ink mb-6" data-id="element-3067">Why Parents Choose Storm</h2>
          <p className="text-xl text-gray-warm" data-id="element-3068">
            We teach more than just kicks and punches. We help parents build
            strong, resilient kids.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-3069">
          {[{
          icon: Shield,
          title: 'Confidence',
          desc: 'To stand tall and speak up.'
        }, {
          icon: Target,
          title: 'Focus',
          desc: 'To listen and pay attention.'
        }, {
          icon: Zap,
          title: 'Discipline',
          desc: 'To do the right thing.'
        }, {
          icon: Heart,
          title: 'Resilience',
          desc: 'To bounce back from failure.'
        }].map((benefit, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-paper p-8 rounded-2xl shadow-soft text-center border border-subtle-gray" data-id="element-3070">
              <div className="w-16 h-16 bg-storm-red/10 rounded-full flex items-center justify-center mx-auto mb-6 text-storm-red" data-id="element-3071">
                <benefit.icon className="w-8 h-8" data-id="element-3072" />
              </div>
              <h3 className="text-2xl text-ink mb-3" data-id="element-3073">{benefit.title}</h3>
              <p className="text-gray-warm" data-id="element-3074">{benefit.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}